const angleAxisTransform = mode => value =>
  mode === '360' && value < 0 ? value + 360 : value;

export default angleAxisTransform;